const traditionalHeaderMenus = [
  {
    Id: '90608c4d-d80e-4a74-b3d6-644590ec6334',
    Name: '關於NCI',
    Title: '關於NCI',
    Type: 0,
    Url: '/cms/content/20346',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: 'abc40f96-0d60-42ca-b65b-54e8cef6e5d5',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: 'c13de078-690e-477f-907c-72c678508654',
    Name: '經營理念',
    Title: '經營理念',
    Type: 0,
    Url: '/cms/content/20348',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: '8aaf5baa-12f8-4ae5-af5e-c5af48953118',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: 'f35da558-5cfe-4632-bf13-5cf8602f3b95',
    Name: '優質服務',
    Title: '優質服務',
    Type: 0,
    Url: '/cms/content/20349',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: '6acd0f22-48a6-4efd-b390-bd53fb752712',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: '947a90cc-8411-4dae-b82e-a839ad263fa7',
    Name: '萬用壽險',
    Title: '萬用壽險',
    Type: 0,
    Url: '/cms/content/20350',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: 'e3632243-3a1c-44e3-8365-70dbc22c87fe',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: 'b3ac369c-cc48-4275-b98a-db2fa34a6fcf',
    Name: '聯繫我們',
    Title: '聯繫我們',
    Type: 0,
    Url: '/cms/content/20347',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: '4be23722-cff1-429a-9e6b-86b4f644eac1',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  }
];

const traditionalFooterMenus = [
  {
    Id: '9bcba247-5e60-4d3b-9e23-df604864969e',
    Name: '關於NCI',
    Title: '關於NCI',
    Type: 0,
    Url: '/cms/content/20346',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: '0b31cb5b-996c-4e4b-b548-e4ccbd605d52',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: 'cce0358f-cb57-46b1-bc33-a6ce2dd82a28',
    Name: '經營理念',
    Title: '經營理念',
    Type: 0,
    Url: '/cms/content/20348',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: 'e95c101d-1192-4dd0-8790-bb8e404dbdcb',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: '6003429e-2f64-4b6a-8f97-a3a7121a7653',
    Name: '優質服務',
    Title: '優質服務',
    Type: 0,
    Url: '/cms/content/20349',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: 'cf730d52-006f-4bca-8032-990d6f02c166',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: 'b047b2f2-4487-470c-a0ff-61ad5ff8daf9',
    Name: '萬用壽險',
    Title: '萬用壽險',
    Type: 0,
    Url: '/cms/content/20350',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: [],
    UrlTransId: 'a72422f2-e7bd-43a8-b855-0b8dc2d8e8fb',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  },
  {
    Id: '87b54bd9-f82a-4cff-9bc8-e31a169420dd',
    Name: '聯繫我們',
    Title: '聯繫我們',
    Type: 0,
    Url: '/cms/content/20347',
    Image: '',
    MobileImage: '',
    Value: { Id: '' },
    Level: 1,
    ParentId: null,
    PlaceTop: false,
    IsNewWin: false,
    IsAnchor: false,
    Childs: null,
    UrlTransId: '99f09e67-95d5-497c-acb5-f35a0de406e3',
    RedirectUrl: null,
    CmsKey: null,
    ParentCmsKey: null
  }
];

const englishHeaderMenus = traditionalHeaderMenus.map((menu, index) => ({
  ...menu,
  Name: [
    'About Us',
    'Business Philosophy',
    'High-quality Service',
    'Universal Life Insurance',
    'Contact Us'
  ][index],
  Title: [
    'About Us',
    'Business Philosophy',
    'High-quality Service',
    'Universal Life Insurance',
    'Contact Us'
  ][index]
}));

const englishFooterMenus = traditionalFooterMenus.map((menu, index) => ({
  ...menu,
  Name: [
    'About Us',
    'Business Philosophy',
    'High-quality Service',
    'Universal Life Insurance',
    'Contact Us'
  ][index],
  Title: [
    'About Us',
    'Business Philosophy',
    'High-quality Service',
    'Universal Life Insurance',
    'Contact Us'
  ][index]
}));

export function getFixedHeaderMenus(lang) {
  return lang === 'E' ? englishHeaderMenus : traditionalHeaderMenus;
}

export function getFixedFooterMenus(lang) {
  return lang === 'E' ? englishFooterMenus : traditionalFooterMenus;
}

export const fixedHeaderMenus = getFixedHeaderMenus(localStorage.getItem('locale'));
export const fixedFooterMenus = getFixedFooterMenus(localStorage.getItem('locale'));
